import React, { useRef, useEffect, useState } from 'react'

import { Scrollbars } from '../Scrollbars/Scrollbars'
import { ModalContainer, Overlay } from './styles'

type IProps = {
    isOpen: boolean
    handleClose: () => void
    headerTitle?: string | number
    headerSubtitle?: string | number
    borderColor?: string
}
export const EntityEditorModal: React.FC<IProps> = ({
    handleClose,
    children,
    isOpen,
    headerTitle,
    headerSubtitle,
    borderColor
}) => {
    const ref = useRef<HTMLDivElement>()

    const [localOpen, setLocalOpen] = useState(isOpen)
    const [animation, setAnimation] = useState(false)

    const handleClickOutside = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (!ref.current.contains(e.target as HTMLDivElement)) {
            handleClose()
        }
    }

    useEffect(() => {
        if (isOpen) {
            setLocalOpen(true)
            setAnimation(true)
        } else {
            setAnimation(false)
            setTimeout(() => setLocalOpen(false), 170)
        }
    }, [isOpen])

    if (localOpen) {
        return (
            <Overlay onMouseDown={e => handleClickOutside(e)}>
                <ModalContainer ref={ref} className={animation ? 'request-open' : 'request-close'}>
                    <div className="classic-row">
                        <div className="left-border classic-col" style={{ background: borderColor }} />
                        <div className="classic-col info">
                            <div className="entity-modal-header">
                                <div className="header-title">{headerTitle}</div>
                                <div className="header-subtitle">{headerSubtitle}</div>
                                <div
                                    className="close-button"
                                    onClick={handleClose}
                                    id="entityModal-header-button-close"
                                >
                                    <i className="far fa-times" />
                                </div>
                            </div>
                            <div className="entity-modal-body">
                                <Scrollbars height="100%">{children}</Scrollbars>
                            </div>
                        </div>
                    </div>
                </ModalContainer>
            </Overlay>
        )
    } else {
        return <></>
    }
}
